export interface ComponentData {
    tag: string
    uuid: string
    sectionId: string

    [key: string]: any
}

export interface Properties {
    [key: string]: any
}

export class Component {
    private element: HTMLElement

    constructor(data: ComponentData) {
        this.element = document.createElement(data.tag)
        this.element.id = data.uuid

        const properties: Properties = { ...data }
        delete properties.tag
        delete properties.uuid
        this.setAttributes(properties)
        this.element.setAttribute('data', JSON.stringify(properties))
    }

    private setAttributes(data: Record<string, any>) {
        for (const [key, value] of Object.entries(data)) {
            this.element.setAttribute(key, JSON.stringify(value))
        }
    }

    public getElement(): HTMLElement {
        return this.element
    }
}
